import React, { type ReactElement, useCallback } from 'react'

import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import KNMenu from 'components/KNMenu/KNMenu'
import KNMenuItem from 'components/KNMenu/KNMenuItem'
import KNMenuLink from 'components/KNMenu/KNMenuLink'
import useMenuState from 'components/KNMenu/useMenuState'
import type { KNDataTableMenuProps } from './types'

const KNDataTableMenu = <T extends object>({
  row,
  label,
  icon,
  actions,
  rightAligned,
}: KNDataTableMenuProps<T>): ReactElement => {
  const {
    anchorEl: actionsAnchorEl,
    open: actionsOpen,
    handleClick: handleActionsClick,
    handleClose: handleActionsClose,
  } = useMenuState()

  const handlePropagation = useCallback((event: React.MouseEvent) => event.stopPropagation(), [])

  return (
    <Box onClick={handlePropagation}>
      <Tooltip title={label} enterDelay={500} placement="top" arrow>
        <IconButton
          onClick={handleActionsClick}
          size="small"
          className="hover-opacity"
          sx={{ color: 'primary.main' }}
        >
          {icon ?? <MoreHorizIcon />}
        </IconButton>
      </Tooltip>
      <KNMenu
        open={actionsOpen}
        onClose={handleActionsClose}
        anchorEl={actionsAnchorEl}
        rightAligned={rightAligned}
      >
        {actions.map((action) => {
          if (action.getLink) {
            return (
              <KNMenuLink
                key={action.name}
                to={action.getLink(row)}
                label={action.label}
                onClick={() => {
                  action.onClick?.(row)
                }}
              />
            )
          }
          return (
            <KNMenuItem
              key={action.name}
              label={action.label}
              onClick={() => {
                action.onClick?.(row)
              }}
              hasBottomBorder={action.bottomBorder}
            />
          )
        })}
      </KNMenu>
    </Box>
  )
}

export default KNDataTableMenu
